<template>
  <div class="lz-field">
    <label class="lz-field-label" for="notesVal">Notes</label>
    <textarea
      id="notesVal"
      rows="3"
      class="form-control"
      style="resize: none"
      placeholder="Add any extra context for this entry (optional)"
      :value="Notes"
      @change="noteChanged"></textarea>
  </div>
</template>

<script>
export default {
  name: 'NotesSelector',
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    Notes() {
      return this.FormData.notes
    }
  },
  methods: {
    noteChanged(ev) {
      const value = ev?.target?.value ?? this.Notes
      if (value.trim() !== this.Notes) {
        this.$store.commit('modifyFormData', {
          key: 'notes',
          value
        })
      }
    }
  }
}
</script>
